import { Box, List, ListItem, ListItemButton, Typography } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';
import { VersionChip } from '~/components/Chip/VersionChip';
import LabeledList from '~/components/LabeledList';
import { PredictionModel } from '~/utils/transforms/predictionModelsDataTransforms';
import LoadingModels from './LoadingModels';
import NoModelsFound from './NoModelsFound';

interface AvailableModelsProps {
    models: PredictionModel[];
    selectedModel?: PredictionModel;
    isLoading?: boolean;
    setSelectedModel: Dispatch<SetStateAction<PredictionModel | undefined>>;
}

export default function AvailableModels({
    models,
    selectedModel,
    setSelectedModel,
    isLoading,
}: AvailableModelsProps) {
    if (isLoading) {
        return <LoadingModels />;
    } else if (models.length <= 0) {
        return <NoModelsFound />;
    }
    return (
        <LabeledList label="Model">
            <List>
                {models.map((model) => (
                    <ListItem key={model.name} disablePadding>
                        <ListItemButton
                            onClick={() => setSelectedModel(model)}
                            selected={selectedModel?.name === model.name}
                        >
                            <Box
                                display="grid"
                                gridTemplateColumns="1fr auto"
                                width="100%"
                                alignItems="center"
                                gap={2}
                            >
                                <Typography fontSize={14}>
                                    {model.label}
                                </Typography>
                                {model.version && (
                                    <VersionChip
                                        version={model.version}
                                        isLatest={model.isLatest}
                                    />
                                )}
                            </Box>
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
        </LabeledList>
    );
}
